import { Avatar } from '@skupreme/shared/ui';

interface IOrganizationCellProps {
  data: {
    logo?: {
      url?: string;
    };
    company_name?: string;
    [key: string]: any;
  };
  options?: {
    showLogo?: boolean;
    containerClass?: string;
    [key: string]: any;
  };
}

export function OrganizationCell({
  data = {},
  options = {},
}: IOrganizationCellProps) {
  if (!data) {
    return <></>;
  }

  const { showLogo = true, containerClass } = options || {};
  const { logo = {}, company_name = '' } = data || {};
  const { url = '' } = logo || {};

  const logoUrl = typeof url === 'string' ? url : '';
  /* Without a logo or a name there is nothing to draw, as before. */
  const showAvatar = showLogo && (logoUrl || company_name);

  return (
    <div
      className={['sk:flex! sk:items-center!', containerClass ?? 'sk:mt-2!']
        .filter(d => !!d)
        .join(' ')}
    >
      {showAvatar ? (
        <Avatar
          src={logoUrl}
          name={company_name}
          size="xs"
          className="sk:mr-2"
        />
      ) : null}
      <span>{company_name || ''}</span>
    </div>
  );
}
